module.exports = __webpack_public_path__ + "static/media/la-provence.24c01082.jpg";